import React from 'react';
import CCRSCalculator from './pages/CCRSCalculator/CCRSCalculator';
import './styles/App.css';

function App() {
  return (
    <div className="App">
      <CCRSCalculator />
    </div>
  );
}

export default App;
